import { AxiosError } from 'axios'

export const loginErrorHandle = {
    onError: (err: AxiosError) => {
        //console.log(err)
    },
}
